// ponytail: stub for the deprecated popper.js v1, aliased in vite.config.js.
//
// Bootstrap 4 lists popper.js as a peer dependency and imports it eagerly, but
// we never reach the code paths that construct it:
//   - the only `data-toggle="dropdown"` lives in a `.navbar`
//     (resources/views/new-homepage/nav.blade.php), and Bootstrap explicitly
//     skips Popper for navbar dropdowns — see "Totally disable Popper for
//     Dropdowns in Navbar" in bootstrap/js/dist/dropdown.js
//   - tooltips/popovers are opt-in in Bootstrap 4 and are never initialised
//   - every other dropdown in the app is Reka UI (shadcn), which uses floating-ui
//
// Bootstrap guards both call sites with `typeof Popper === 'undefined'`, so if
// someone adds a non-navbar dropdown or initialises a tooltip they get a loud
// `TypeError: Bootstrap's dropdowns require Popper` instead of silent breakage.
// Ceiling: if we ever need real positioning from Bootstrap JS, drop this stub
// and move to Bootstrap 5 (which uses the maintained @popperjs/core v2).
export default undefined
